import 'twin.macro'

import TwoCardsIcon from 'assets/icons/TwoCardsIcon'
import Modal from 'components/UI/modal/modal'
import Title from 'components/UI/title/title'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { pathnames } from 'utils/steps'

import CardImg from './../../../assets/images/mega_syiliq_card_img.webp'

function BuyCardContainer() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const onClick = () => {
    navigate(`${pathnames['buy-card']}`)
  }

  return (
    <>
      <div
        tw='bg-primary p-8 rounded-s20 flex flex-col items-center h-full pt-20 justify-between min-h-[368px]'
        className='dashed-container'
      >
        <img src={CardImg} alt='' width={90} />
        <button
          tw='h-[46px] w-full rounded-s20 text-s14 font-medium bg-secondary flex gap-2 items-center justify-center'
          onClick={onClick}
        >
          <span tw='text-[18px]'>+</span>
          {t('card.buy_more', { ns: 'cabinet' })}
        </button>
      </div>
    </>
  )
}

export default BuyCardContainer
